import { ThemeEvents } from '@theme/events';

class ProductPrice extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;

    section.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);

    // 🔥 watch DOM changes (fixes AJAX loader issue)
    this.observer = new MutationObserver(() => {
      this.forcePriceVisibility();
    });

    this.observer.observe(this, {
      childList: true,
      subtree: true,
    });

    // initial fix after render
    requestAnimationFrame(() => {
      this.forcePriceVisibility();
    });
  }

  disconnectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (section) {
      section.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
    }

    if (this.observer) {
      this.observer.disconnect();
    }
  }

  updatePrice = (event) => {
    const newPrice = event.detail?.data?.html?.querySelector(
      'product-price [ref="priceContainer"]'
    );

    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    currentPrice.innerHTML = newPrice.innerHTML;

    // 🔥 delay fix after AJAX replaces DOM
    requestAnimationFrame(() => {
      this.forcePriceVisibility();
    });
  };

  forcePriceVisibility() {
    const container = this.querySelector('[ref="priceContainer"]');
    if (!container) return;

    // ALWAYS force visibility (fix loader hiding)
    container.style.display = 'block';
    container.style.opacity = '1';
    container.style.visibility = 'visible';

    // price always visible
    container.querySelectorAll('.price, .compare-at-price').forEach((el) => {
      el.style.display = 'inline-block';
      el.style.opacity = '1';
    });

    // 🔥 IMPORTANT: check inside THIS product only (not document)
    const hasDiscount =
      this.querySelector('.ddp-discounts.ddp-discounts-container');

    if (!hasDiscount) {
      container.classList.add('no-discount');
    } else {
      container.classList.remove('no-discount');
    }
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}